import states from "states-us";

import {
  MarketplaceFormElement,
  MarketplaceFormElementRole,
  MarketplaceFormElementType,
  MarketplaceFormElementWidget,
  MarketplaceOptionGridType,
} from "../../../schema/generated/schema";

export const elementsArrangement = [
  "name",
  "street1",
  "street2",
  "country",
  "city",
  "state",
  "zipcode",
  "phoneNumber",
  "emailAddress",
  "setDefaultAddress",
];

const defaultPropsForElements = {
  buyerAccess: { editable: true, hidden: false },
  clearWhenChanged: [],
  sellerAccess: { editable: true, hidden: false },
  widget: null,
  optionValues: [],
  optionType: null,
  optionSourceExternalId: null,
  dateOptionValues: "",
  grid: MarketplaceOptionGridType.Auto,
  validation: null,
  required: false,
  label: "",
  tooltip: "",
  description: "",
  defaultValue: null,
  min: null,
  max: null,
  regex: null,
  allowedFileExtensions: null,
  role: MarketplaceFormElementRole.None,
  hideIf: null,
  placeholder: null,
};

export const elements: MarketplaceFormElement[] = [
  {
    type: MarketplaceFormElementType.Text,
    key: "name",
    ...defaultPropsForElements,
    widget: MarketplaceFormElementWidget.ShortPlainText,
  },
  {
    type: MarketplaceFormElementType.Text,
    key: "phoneNumber",
    ...defaultPropsForElements,
    widget: MarketplaceFormElementWidget.Phone,
  },
  {
    type: MarketplaceFormElementType.Text,
    key: "street1",
    ...defaultPropsForElements,
  },
  {
    type: MarketplaceFormElementType.Text,
    key: "street2",
    ...defaultPropsForElements,
    widget: MarketplaceFormElementWidget.WithoutLabel,
  },
  {
    type: MarketplaceFormElementType.Select,
    key: "country",
    ...defaultPropsForElements,
    buyerAccess: { editable: false, hidden: false },
    sellerAccess: { editable: false, hidden: false },
  },
  {
    type: MarketplaceFormElementType.Text,
    key: "city",
    ...defaultPropsForElements,
    widget: MarketplaceFormElementWidget.ShortPlainText,
  },
  {
    type: MarketplaceFormElementType.Select,
    key: "state",
    ...defaultPropsForElements,
  },
  {
    type: MarketplaceFormElementType.Text,
    key: "zipcode",
    ...defaultPropsForElements,
    widget: MarketplaceFormElementWidget.ShortPlainText,
  },
  {
    type: MarketplaceFormElementType.Text,
    key: "emailAddress",
    ...defaultPropsForElements,
    widget: MarketplaceFormElementWidget.ShortPlainText,
  },
  {
    type: MarketplaceFormElementType.Bool,
    key: "setDefaultAddress",
    ...defaultPropsForElements,
  },
];

export const schema: any = {
  type: "object",
  title: "Add an Address",
  required: [
    "name",
    "street1",
    "country",
    "city",
    "state",
    "zipcode",
    "phoneNumber",
    "emailAddress",
  ],
  properties: {
    // The name of the person or department to which this should be directed (aka attn in api)
    name: { type: "string", title: "Full Name" },
    street1: {
      type: "string",
      title: "Street Address",
    },
    street2: { type: "string" },
    country: {
      type: "string",
      title: "Country",
      anyOf: [
        {
          type: "string",
          title: "United States",
          enum: ["US"],
        },
        {
          type: "string",
          title: "Canada",
          enum: ["CA"],
        },
        {
          type: "string",
          title: "Other",
          enum: [""],
        },
      ],
    },
    city: { type: "string", title: "City" },
    state: {
      type: "string",
      title: "State",
      anyOf: [
        {
          type: "string",
          title: "",
          enum: [""],
        },
      ].concat(
        states.map(({ name, abbreviation }) => ({
          type: "string",
          title: name,
          enum: [abbreviation],
        }))
      ),
    },
    zipcode: {
      type: "string",
      title: "Zip",
    },
    phoneNumber: {
      type: "string",
      title: "Phone Number",
    },
    emailAddress: {
      type: "string",
      title: "Email",
      pattern:
        "^[a-zA-Z0-9.!#$%&‘*+/=?^_`{|}~-]+@(?!.*\\.\\.)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$",
    },
    setDefaultAddress: {
      type: "boolean",
      title: "Make this my default shipping address.",
    },
  },
};
